import { Controller } from "@hotwired/stimulus";

// Controls a list of attachments (aka, an "attachment proxy").
export default class extends Controller {
  static targets = ["form"];
  static values = { multiple: Boolean };

  // On submit, be pessimistic. If anything needs to change, do it with turbo
  // streams. Otherwise, there's a lag between changes from Stimulus and the
  // changes from Turbo Stream.
  submit() {
    this.formTarget.requestSubmit();
  }

  // On update, be optimistic. Do the immediate changes with Stimulus and let
  // Turbo Streams catch up.
  update() {
    if (this.#single) this.showForm();
  }

  hideForm() {
    this.formTarget.classList.add("hidden");
  }

  showForm() {
    this.formTarget.classList.remove("hidden");
  }

  /* Private */

  get #single() {
    return !this.multipleValue;
  }
}
